define('OutSystems/ReactWidgets/DropdownCustom',["require", "exports", "tslib", "classnames", "OutSystems/ClientRuntime/DataConversion", "OutSystems/ClientRuntime/DataTypes", "OutSystems/ClientRuntime/Settings", "OutSystems/ReactView/Widget", "react", "./Utils"], function (require, exports, tslib_1, classNames, DataConversion_1, DataTypes_1, Settings_1, Widget_1, React, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DropdownCustom = void 0;
    var DropdownCustom = (function (_super) {
        tslib_1.__extends(DropdownCustom, _super);
        function DropdownCustom(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.selectedValue = null;
            _this.state = {
                listVisible: false,
                position: { left: "0px", top: "0px", width: "0px", height: "0px" },
            };
            return _this;
        }
        DropdownCustom_1 = DropdownCustom;
        DropdownCustom.prototype.select = function (item) {
            if (this.variable.value === item) {
                this.hide();
            }
            else {
                this.variable.value = item;
                this.selectedValue = item;
                this.setState({ listVisible: false });
                if (this.props.onChange) {
                    this.props.onChange();
                }
            }
        };
        Object.defineProperty(DropdownCustom.prototype, "variable", {
            get: function () {
                return this.props.variable;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DropdownCustom.prototype, "htmlElement", {
            get: function () {
                return this.element;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DropdownCustom.prototype, "isMandatory", {
            get: function () {
                return this.props.mandatory;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DropdownCustom.prototype, "inputedValue", {
            get: function () {
                return this.isValueInList(this.selectedValue) ? this.selectedValue : null;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DropdownCustom.prototype, "inputedValueValidity", {
            get: function () {
                var variableValue = this.isValueInList(this.selectedValue);
                var validity = {
                    valid: variableValue,
                    badInput: false,
                };
                return validity;
            },
            enumerable: false,
            configurable: true
        });
        DropdownCustom.prototype.componentDidMount = function () {
            this.setVariable();
            this.element = this.getHTMLNode();
            this.updateState();
            this.scrollIntoSelectedElement();
        };
        DropdownCustom.prototype.componentDidUpdate = function () {
            this.setVariable();
            this.updateState();
            this.scrollIntoSelectedElement();
            this.focusCorrectElement();
        };
        DropdownCustom.prototype.isValueInList = function (value) {
            if (this.props.list && this.props.list.length > 0) {
                for (var i = 0; i < this.props.list.length; i++) {
                    var itemValue = this.props.values(this.props.list.getItem(i));
                    if ((0, DataTypes_1.equals)(itemValue, value)) {
                        return true;
                    }
                }
            }
            return false;
        };
        DropdownCustom.prototype.setVariable = function () {
            if (this.props.list && this.props.list.length > 0) {
                var valueFound = this.isValueInList(this.variable.value);
                if (!valueFound) {
                    if (this.isEmptyValueDefined()) {
                        this.selectedValue = this.variable.value;
                    }
                    else {
                        var newValue = this.props.values(this.props.list.getItem(0));
                        if (!(0, DataTypes_1.equals)(newValue, this.variable.value)) {
                            this.variable.value = newValue;
                            this.selectedValue = newValue;
                            if (this.props.onChange) {
                                this.props.onChange();
                            }
                        }
                    }
                }
            }
        };
        DropdownCustom.prototype.show = function () {
            this.offsetLeft = this.htmlElement.getBoundingClientRect().left;
            this.setState({ listVisible: true });
        };
        DropdownCustom.prototype.hide = function (event) {
            if (event === void 0) { event = null; }
            if (event) {
                event.stopPropagation();
            }
            this.setState({ listVisible: false });
        };
        DropdownCustom.prototype.updateState = function () {
            var dropdownNode = this.getHTMLNode();
            var dropdownDisplay = dropdownNode.childNodes[0];
            var dropdownLabel = dropdownDisplay.childNodes[0];
            var dropdownList = dropdownNode.childNodes[1];
            if (!dropdownList) {
                dropdownNode.classList.remove(DropdownCustom_1.DropdownExpandedDown);
                dropdownNode.classList.remove(DropdownCustom_1.DropdownExpandedUp);
                dropdownNode.classList.remove(DropdownCustom_1.DropdownExpanded);
            }
            if (dropdownNode && dropdownDisplay && dropdownList && dropdownLabel) {
                var newposition = {
                    left: "",
                    top: "",
                    width: "",
                    height: "",
                };
                var dropdownLabelRect = dropdownLabel.getBoundingClientRect();
                var dropdownDisplayRect = dropdownDisplay.getBoundingClientRect();
                var viewportTop = window.pageYOffset;
                var viewportLeft = window.pageXOffset;
                var labelOffsetLeft = Math.round(dropdownLabelRect.left + viewportLeft);
                var labelOffsetRight = Math.round(dropdownLabelRect.right + viewportLeft);
                var displayOffsetTop = Math.round(dropdownDisplayRect.top + viewportTop);
                var displayOffsetBottom = Math.round(dropdownDisplayRect.bottom + viewportTop);
                var listRect = dropdownList.getBoundingClientRect();
                var popupHeight = Math.round(listRect.height);
                var popupWidth = Math.round(listRect.width);
                var viewportBottom = viewportTop + window.innerHeight;
                var centerX = (labelOffsetLeft + labelOffsetRight) / 2;
                var width = void 0;
                var left = void 0;
                if (window.innerWidth <= DropdownCustom_1.SmartphonePortraitWidth) {
                    width = window.innerWidth - 2 * DropdownCustom_1.PopupBoxMargin;
                    newposition.width = Math.round(width) + "px";
                    left = viewportLeft + DropdownCustom_1.PopupBoxMargin;
                }
                else {
                    width = popupWidth;
                    if (this.state.listVisible) {
                        left = this.offsetLeft;
                    }
                    else {
                        left = Math.max(viewportLeft, centerX - width / 2);
                    }
                }
                var top_1;
                var height = void 0;
                var popupOpened = document.querySelector("[data-popup]");
                var popupRect = popupOpened ? popupOpened.getBoundingClientRect() : null;
                var viewportTopMin = popupRect ? popupRect.top : viewportTop;
                if (displayOffsetTop - viewportTopMin > viewportBottom - displayOffsetBottom) {
                    dropdownNode.classList.add(DropdownCustom_1.DropdownExpanded, DropdownCustom_1.DropdownExpandedUp);
                    dropdownNode.classList.remove(DropdownCustom_1.DropdownExpandedDown);
                    top_1 = displayOffsetTop - popupHeight;
                    if (top_1 < viewportTopMin - DropdownCustom_1.PopupBoxMargin) {
                        top_1 = viewportTopMin + DropdownCustom_1.PopupBoxMargin;
                        height = displayOffsetTop - viewportTopMin - DropdownCustom_1.PopupBoxMargin;
                        newposition.height = Math.round(height) + "px";
                    }
                }
                else {
                    dropdownNode.classList.add(DropdownCustom_1.DropdownExpanded, DropdownCustom_1.DropdownExpandedDown);
                    dropdownNode.classList.remove(DropdownCustom_1.DropdownExpandedUp);
                    top_1 = displayOffsetBottom;
                    if (top_1 + popupHeight > viewportBottom - DropdownCustom_1.PopupBoxMargin) {
                        height = viewportBottom - displayOffsetBottom - DropdownCustom_1.PopupBoxMargin;
                        newposition.height = Math.round(height) + "px";
                    }
                }
                newposition.left = Math.round(left) + "px";
                newposition.top = Math.round(top_1) + "px";
                if (this.state.position.left !== newposition.left ||
                    this.state.position.top !== newposition.top ||
                    this.state.position.width !== newposition.width ||
                    (this.state.position.height !== newposition.height && newposition.height !== "")) {
                    this.setState({ position: newposition });
                }
            }
        };
        DropdownCustom.prototype.isEmptyValueDefined = function () {
            return this.props.emptyValue && this.props.emptyValue.length > 0;
        };
        DropdownCustom.prototype.prepareDropdownContainerAttributes = function () {
            var _this = this;
            var dropdownContainerAttributes = {
                "data-dropdown": "",
                className: DropdownCustom_1.DropdownContainer + " " + this.props.style,
                onKeyDown: function (event) {
                    if (!_this.state.listVisible) {
                        if (event.key === Utils_1.KeyboardKey.ENTER_KEY || event.key === Utils_1.KeyboardKey.SPACE_KEY) {
                            event.stopPropagation();
                            if (_this.props.enabled) {
                                _this.show();
                            }
                        }
                    }
                    else {
                        switch (event.key) {
                            case Utils_1.KeyboardKey.ENTER_KEY:
                            case Utils_1.KeyboardKey.SPACE_KEY:
                                event.stopPropagation();
                                var listElement = _this.getHTMLNode().querySelector(".".concat(DropdownCustom_1.DropdownPopUpRow));
                                if (!listElement) {
                                    var emptyValue = DataConversion_1.JSConversions.convertTo(null, _this.variable.type);
                                    _this.selectedValue = emptyValue;
                                    _this.setState({ listVisible: false });
                                    _this.focusClosedDropdown();
                                }
                                break;
                            case Utils_1.KeyboardKey.ARROW_DOWN:
                                _this.navigateList("down");
                                break;
                            case Utils_1.KeyboardKey.ARROW_UP:
                                _this.navigateList("up");
                                break;
                            default:
                                _this.hide();
                                _this.focusClosedDropdown();
                                break;
                        }
                    }
                },
            };
            this.fillWithBuiltinProperties(dropdownContainerAttributes);
            return dropdownContainerAttributes;
        };
        DropdownCustom.prototype.focusCorrectElement = function () {
            if (this.state.listVisible) {
                var dropdownList = this.getHTMLNode().childNodes[1];
                if (dropdownList) {
                    var firstElement = dropdownList.getElementsByClassName(DropdownCustom_1.DropdownPopUpRow)[0];
                    var selectedElement = dropdownList.getElementsByClassName(DropdownCustom_1.DropdownPopUpRowSelected)[0];
                    if (selectedElement) {
                        selectedElement.focus();
                    }
                    else if (firstElement) {
                        firstElement.focus();
                    }
                }
            }
        };
        DropdownCustom.prototype.focusClosedDropdown = function () {
            var dropdown = this.getHTMLNode();
            var focusElement = dropdown.getElementsByClassName(DropdownCustom_1.DropdownDisplay)[0];
            focusElement === null || focusElement === void 0 ? void 0 : focusElement.focus();
        };
        DropdownCustom.prototype.navigateList = function (direction) {
            var dropdownList = this.getHTMLNode().childNodes[1];
            if (dropdownList) {
                var selectedElement = dropdownList.getElementsByClassName(DropdownCustom_1.DropdownPopUpRowSelected)[0];
                var nextElement = null;
                if (selectedElement) {
                    selectedElement.focus();
                    if (direction === "down") {
                        nextElement = selectedElement.nextElementSibling;
                    }
                    else {
                        nextElement = selectedElement.previousElementSibling;
                    }
                }
                else {
                    nextElement = dropdownList.getElementsByClassName(DropdownCustom_1.DropdownPopUpRow)[0];
                }
                if (nextElement) {
                    selectedElement === null || selectedElement === void 0 ? void 0 : selectedElement.classList.remove(DropdownCustom_1.DropdownPopUpRowSelected);
                    nextElement.classList.add(DropdownCustom_1.DropdownPopUpRowSelected);
                    nextElement.tabIndex = 0;
                    nextElement.focus();
                }
            }
        };
        DropdownCustom.prototype.prepareDropdownDisplayAttributes = function () {
            var _this = this;
            var dropdownDisplayAttributes = tslib_1.__assign({ className: DropdownCustom_1.DropdownDisplay + (this.props.enabled ? "" : " " + DropdownCustom_1.DropdownDisabled), tabIndex: 0, onClick: function (event) {
                    event.stopPropagation();
                    if (_this.props.enabled) {
                        _this.show();
                    }
                } }, ((0, Settings_1.getEnvParams)().EnableWCAG22 && {
                role: "combobox",
                "aria-expanded": this.state.listVisible,
                "aria-haspopup": "listbox",
                "aria-controls": this.state.listVisible ? this.getId() + DropdownCustom_1.ListboxIdSuffix : undefined,
            }));
            return dropdownDisplayAttributes;
        };
        DropdownCustom.prototype.renderEmptyValue = function () {
            var _a;
            var _this = this;
            var selectedElement = null;
            var emptyValueItem = null;
            if (this.isEmptyValueDefined()) {
                var isValueInList = this.isValueInList(this.variable.value);
                var emptySpan = React.createElement("span", null, this.props.emptyValue);
                var emptyValueItemAttributes = tslib_1.__assign(tslib_1.__assign({ className: classNames(DropdownCustom_1.DropdownPopUpRow, DropdownCustom_1.DropdownEmptyValueRow, (_a = {},
                        _a[DropdownCustom_1.DropdownPopUpRowSelected] = !isValueInList,
                        _a)), tabIndex: 0 }, ((0, Settings_1.getEnvParams)().EnableWCAG22 && {
                    role: "option",
                    "aria-selected": !isValueInList,
                })), { onClick: function (_event) {
                        var emptyValue = DataConversion_1.JSConversions.convertTo(null, _this.variable.type);
                        _this.variable.value = emptyValue;
                        _this.selectedValue = emptyValue;
                        if (_this.props.onChange) {
                            _this.props.onChange();
                        }
                        _this.setState({ listVisible: false });
                    }, onKeyDown: function (event) {
                        if (event.key === Utils_1.KeyboardKey.ENTER_KEY || event.key === Utils_1.KeyboardKey.SPACE_KEY) {
                            event.stopPropagation();
                            var emptyValue = DataConversion_1.JSConversions.convertTo(null, _this.variable.type);
                            _this.variable.value = emptyValue;
                            _this.selectedValue = emptyValue;
                            _this.setState({ listVisible: false });
                        }
                    } });
                emptyValueItem = React.createElement("div", tslib_1.__assign({}, emptyValueItemAttributes), emptySpan);
                if (!isValueInList) {
                    selectedElement = emptySpan;
                }
            }
            return {
                selectedElement: selectedElement,
                emptyValueItem: emptyValueItem,
            };
        };
        DropdownCustom.prototype.renderDropdownList = function (emptyValueItem) {
            var _this = this;
            var dropdownList = null;
            var selectedElement = null;
            var dropdownListAttributes = tslib_1.__assign({ className: DropdownCustom_1.DropdownList, style: this.state.position }, ((0, Settings_1.getEnvParams)().EnableWCAG22 && {
                role: "listbox",
                id: this.getId() + DropdownCustom_1.ListboxIdSuffix,
            }));
            dropdownList = (React.createElement("div", tslib_1.__assign({}, dropdownListAttributes),
                React.createElement("div", { className: DropdownCustom_1.ScrollableList + " " + DropdownCustom_1.ScrollableListWithScroll },
                    emptyValueItem,
                    this.props.placeholders.content.render(this, this.props.list, function (element, index) {
                        var value = null;
                        value = _this.props.values(_this.props.list.getItem(index));
                        var listDivAttributes = tslib_1.__assign({ onClick: function (_event) { return _this.select(value); }, className: DropdownCustom_1.DropdownPopUpRow, onKeyDown: function (event) {
                                if (event.key === Utils_1.KeyboardKey.ENTER_KEY || event.key === Utils_1.KeyboardKey.SPACE_KEY) {
                                    event.stopPropagation();
                                    _this.select(value);
                                    _this.focusClosedDropdown();
                                }
                            } }, ((0, Settings_1.getEnvParams)().EnableWCAG22 && {
                            role: "option",
                            "aria-selected": (0, DataTypes_1.equals)(value, _this.variable.value),
                        }));
                        if ((0, DataTypes_1.equals)(value, _this.variable.value)) {
                            selectedElement = element;
                            _this.selectedValue = _this.variable.value;
                            listDivAttributes.className =
                                listDivAttributes.className + " " + DropdownCustom_1.DropdownPopUpRowSelected;
                            listDivAttributes.tabIndex = 0;
                        }
                        return React.createElement("div", tslib_1.__assign({}, listDivAttributes), element);
                    }))));
            return {
                list: dropdownList,
                selectedElement: selectedElement,
            };
        };
        DropdownCustom.prototype.scrollIntoSelectedElement = function () {
            var dropdownList = this.getHTMLNode().childNodes[1];
            if (dropdownList) {
                var selectedElement = dropdownList.getElementsByClassName(DropdownCustom_1.DropdownPopUpRowSelected)[0];
                if (selectedElement) {
                    var parentWithScroll = this.getScrollParent(selectedElement, dropdownList);
                    if (dropdownList === parentWithScroll || dropdownList.contains(parentWithScroll)) {
                        var pos = selectedElement.offsetTop;
                        var parentPos = parentWithScroll.offsetTop;
                        parentWithScroll.scrollTop = pos - parentPos;
                    }
                }
            }
        };
        DropdownCustom.prototype.getScrollParent = function (node, stopElement) {
            if (node === null) {
                return null;
            }
            if (node.scrollHeight > node.clientHeight) {
                return node;
            }
            else {
                if (node === stopElement) {
                    return null;
                }
                else {
                    return this.getScrollParent(node.parentElement, stopElement);
                }
            }
        };
        DropdownCustom.prototype.renderDropdownBackground = function () {
            var _this = this;
            if (this.state.listVisible) {
                var dropdownBackgroundStyle = {
                    width: "100%",
                    height: "100%",
                    position: "fixed",
                    top: "0px",
                    left: "0px",
                };
                var dropdownBackground = (React.createElement("div", { className: DropdownCustom_1.DropdownBackgroundWindow, style: dropdownBackgroundStyle, onClick: function (event) { return _this.hide(event); } }));
                return dropdownBackground;
            }
            else {
                return null;
            }
        };
        DropdownCustom.prototype.render = function () {
            var emptyValue = this.renderEmptyValue();
            var dropdownList = this.renderDropdownList(emptyValue ? emptyValue.emptyValueItem : null);
            var dropdownDisplayAttributes = this.prepareDropdownDisplayAttributes();
            var dropdownDisplay = (React.createElement("div", tslib_1.__assign({}, dropdownDisplayAttributes),
                React.createElement("div", { className: DropdownCustom_1.DropdownDisplayContent }, dropdownList.selectedElement
                    ? dropdownList.selectedElement
                    : emptyValue
                        ? emptyValue.selectedElement
                        : null)));
            return (React.createElement("div", tslib_1.__assign({}, this.prepareDropdownContainerAttributes()),
                dropdownDisplay,
                this.state.listVisible ? dropdownList.list : null,
                this.renderDropdownBackground(),
                this.createValidationElement()));
        };
        var DropdownCustom_1;
        DropdownCustom.SmartphonePortraitWidth = 420;
        DropdownCustom.PopupBoxMargin = 10;
        DropdownCustom.DropdownList = "dropdown-list";
        DropdownCustom.DropdownContainer = "dropdown-container";
        DropdownCustom.DropdownDisplay = "dropdown-display";
        DropdownCustom.DropdownDisplayContent = "dropdown-display-content";
        DropdownCustom.DropdownDisabled = "dropdown-disabled";
        DropdownCustom.DropdownPopUpRow = "dropdown-popup-row";
        DropdownCustom.DropdownPopUpRowSelected = "dropdown-popup-row-selected";
        DropdownCustom.DropdownEmptyValueRow = "dropdown-empty-value-row";
        DropdownCustom.DropdownBackgroundWindow = "dropdown-background-window";
        DropdownCustom.ScrollableList = "scrollable-list";
        DropdownCustom.ScrollableListWithScroll = "scrollable-list-with-scroll";
        DropdownCustom.DropdownExpanded = "dropdown-expanded";
        DropdownCustom.DropdownExpandedUp = "dropdown-expanded-up";
        DropdownCustom.DropdownExpandedDown = "dropdown-expanded-down";
        DropdownCustom.ListboxIdSuffix = "-listbox";
        DropdownCustom = DropdownCustom_1 = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], DropdownCustom);
        return DropdownCustom;
    }(Widget_1.InputWithVariableWidget));
    exports.DropdownCustom = DropdownCustom;
});
//# sourceMappingURL=DropdownCustom.js.map;
